<template>
	<div class="result">
		<transition name="slide-fade">
			<div class="answer-wrap">
				<div class="answer-title">
					★結果B
					<div class="text">生活習慣を中心に改善してみましょう</div>
				</div>
				<div class="answer-body">
					<p>睡眠の質UPには、生活習慣と睡眠環境（寝室や寝具）の両方を整えることが大切。あなたの場合、とくに生活習慣に改善の余地がありそうです。</p>
					<div class="sub-cts"><h2>★改善へのアドバイス</h2>
						<p>
							まずは毎日同じ時刻に起床・就寝することを心がけ、体内時計を整えましょう。睡眠リズムを乱してしまう「休日の寝溜め」はNGです。また、40℃前後のぬるめの湯舟に約10分浸かって体を温めましょう。就寝の90～30分前がおすすめです。そして、ブルーライトを発するスマホ・パソコン・タブレット等は就寝直前の使用をできるだけ控えましょう。</p>
					</div>
					<div class="sub-cts">
						<h2>▼こちらもCHECK</h2>
						<ul>
							<li><a href="https://xn--z8js3azm.com/beauty/10">体内時計は2種類あるって知ってた？それぞれを整えて眠りの悩みを解消する3つのコツ</a></li>
						</ul>
					</div>
				</div>
				<div class="btn-area">
					<button @click="next(0)" class="btnReset">スタートに戻る</button>
				</div>
			</div>
		</transition>
	</div>
</template>
<script>
export default {
	name: 'ResultCts02',
	methods: {
		next(page) {
			this.$store.dispatch('next', page)
		},
		onComplete: function () {
			this.btnFlg = true;
		}
	}
}
</script>
